export default __webpack_public_path__ + "static/media/bg.050af5ff.png";